import { BookingStoreNamespace } from "../../modules/booking/store";
import { UPDATE_MANY_FILES, ARTIST_FILES, UPDATE_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO_FILES } from "../../modules/booking/store/types";

export const fileAddedActionMapper = {
  // 'calendar_dates': `${BookingStoreNamespace}/${UPDATE_MANY_FILES}`,
  // 'artists': `${BookingStoreNamespace}/${ARTIST_FILES.UPDATE.ALL}`,
};

// export const fileDeletedActionMapper = {
//   'calendar_dates': `${BookingStoreNamespace}/${SET_MANY_FILES}`,
//   'artists': `${BookingStoreNamespace}/${ARTIST_FILES.UPDATE.ALL}`,
// }
